import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import { BackButton } from "../components/back-button";
import { Button } from "../components/ui/button";
import { MitigationCard } from "../components/mitigation-card";
import { IRiskCategoryData, MitigationType } from "../../store/playbook-analysis-slice";
import { RootState } from "../../store/store";

export function KeyTermMitigations() {
	const navigate = useNavigate();
	const { type, keyTermIdx } = useParams();

	const keyTerms: IRiskCategoryData = useSelector((state: RootState) => state.analysis[type]);

	if (keyTerms.risks.length <= Number(keyTermIdx)) {
		navigate("/analyze");
		return null;
	}

	const keyTermMitigations = keyTerms.risks.at(Number(keyTermIdx));

	return (
		<div className="px-2 py-4">
			<BackButton />

			<div className="flex items-center justify-between gap-4 mt-2">
				<h1 className="text-lg font-bold">{keyTermMitigations.key.replace(/\s*\(\d+\)$/, "")}</h1>
				<div className="size-7 rounded-full font-semibold text-sm grid items-center justify-center bg-red-100 text-red-500 shrink-0">
					{keyTermMitigations.values.length ?? 0}
				</div>
			</div>

			<div className="pb-20">
				{keyTermMitigations.values.map(({ risk_id }, idx) => (
					<MitigationCard
						key={risk_id}
						keyTermIdx={Number(keyTermIdx)}
						mitigationIdx={idx}
						type={type as MitigationType}
					/>
				))}
			</div>

			<div className="fixed bottom-0 left-14 right-0 bg-white border-t-2 px-3 py-2">
				<div className="grid grid-cols-2 gap-3">
					<Button
						size="sm"
						variant="outline"
						disabled={Number(keyTermIdx) === 0}
						onClick={() => navigate(`/analyze/${type}/${Number(keyTermIdx) - 1}`)}
					>
						Previous
					</Button>
					<Button
						size="sm"
						disabled={Number(keyTermIdx) === keyTerms.risks.length - 1}
						className="disabled:cursor-not-allowed"
						onClick={() => navigate(`/analyze/${type}/${Number(keyTermIdx) + 1}`)}
					>
						Next
					</Button>
				</div>
			</div>
		</div>
	);
}
